export default __webpack_public_path__ + "static/media/importance.b3f47db7.svg";